import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Building2 } from "lucide-react";
import SiteFooter from "@/components/site/SiteFooter";

/**
 * Reusable static-page layout used by Terms, Privacy, Refund, Grievance, etc.
 * Props:
 *   - title, subtitle
 *   - lastUpdated (string, e.g., "22 February 2026")
 *   - children (page body)
 */
export default function LegalPageLayout({ title, subtitle, lastUpdated, children, testId = "legal-page" }) {
  return (
    <div className="min-h-screen bg-slate-50" data-testid={testId}>
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-md bg-slate-950 text-white flex items-center justify-center">
              <Building2 className="h-5 w-5" />
            </div>
            <div className="leading-tight">
              <div className="font-heading font-bold text-slate-950">Rana Associates</div>
              <div className="text-xs text-slate-500">Pan-Rajasthan · Property Valuation</div>
            </div>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-950"
            data-testid="legal-back-home"
          >
            <ArrowLeft className="h-4 w-4" /> Back home
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="mb-10 pb-8 border-b border-slate-200">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-700">Legal</p>
          <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-bold text-slate-950">{title}</h1>
          {subtitle && <p className="mt-3 text-slate-600 text-base leading-relaxed">{subtitle}</p>}
          {lastUpdated && (
            <p className="mt-4 text-xs text-slate-500">Last updated: <span className="font-semibold text-slate-700">{lastUpdated}</span></p>
          )}
        </div>

        <article className="prose prose-slate max-w-none text-slate-700 leading-relaxed">
          {children}
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}
